<template src="./index.html"></template>

<script>
	import {
		getdata
	} from './data.js';
	import configHttp from '../../../../../configHttp.js'
	import html2canvas from "html2canvas";
	import vueQr from 'vue-qr';
	export default {
		components: {
			vueQr
		},
		data() {
			return {
				yxkdiag: false,
				qrtext: "https://test-csgj-web.vatunion.com/h5/#/?id=123",
				value1:false,
				value2:false,
			};
		},
		mounted() {
			this.page()
		},
		created() {},
		methods: {
			fordelete() {
				this.yxkdiag = false
			},
			/*保存图片的方法（即按钮点击触发的方法）
			  第一个参数为需要保存的div的id名  
			  第二个参数为保存图片的名称 */
			fordownload(divText, imgText) {
				let canvasID = this.$refs[divText];
				let that = this;
				let a = document.createElement('a');
				var shareContent = canvasID;
				var width = 450;
				var height = 613.63;
				var canvasx = document.createElement("canvas");
				var scale = 4;
				canvasx.width = width * scale;
				canvasx.height = height * scale;
				canvasx.getContext("2d").scale(scale, scale);
				var opts = {
					backgroundColor: 'rgba(0, 101, 177, 1)',
					scale: scale, // 缩放
					canvasx: canvasx,
					width: width,
					height: height
				};
				html2canvas(canvasID,
					opts
				).then(canvas => {
					let dom = document.body.appendChild(canvas);
					dom.style.display = 'none';
					a.style.display = 'none';
					document.body.removeChild(dom);
					let blob = that.dataURLToBlob(dom.toDataURL('image/png'));
					a.setAttribute('href', URL.createObjectURL(blob));
					//这块是保存图片操作  可以设置保存的图片的信息
					a.setAttribute('download', imgText + '.png');
					document.body.appendChild(a);
					a.click();
					URL.revokeObjectURL(blob);
					document.body.removeChild(a);
				});
			},
			dataURLToBlob(dataurl) {
				console.log(dataurl)
				let arr = dataurl.split(',');
				let mime = arr[0].match(/:(.*?);/)[1];
				let bstr = atob(arr[1]);
				let n = bstr.length;
				let u8arr = new Uint8Array(n);
				while (n--) {
					u8arr[n] = bstr.charCodeAt(n);
				}
				return new Blob([u8arr], {
					type: mime
				});
			},
		}
	};
</script>

<style scoped lang="less">
	@import url('./index.less');
</style>